export default __webpack_public_path__ + "html5.76b738bf.png";